import Ordinance from './Ordinance'

export default class SealingToParentOrdinance extends Ordinance {
  constructor(sealingToParents, t) {
    super({
      data: sealingToParents,
      title: t('wcf.person-ordinances.sealingtoparents', 'Sealing to Parents'),
      t,
    })
  }
}
